import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'usb-confirm-items',
  templateUrl: './confirm-items.component.html',
  styleUrls: ['./confirm-items.component.scss']
})
export class ConfirmItemsComponent implements OnInit {

  @Input() items:any;
  @Input() currencyItinerary: string;
  @Input() currencies: any[] = [];
  @Input() currencyAgency: any;
  @Input() clientSetting: any;
  rate
  @Output() nextStep = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }


  goStepThree(){
    this.items.forEach(element => {
      element.selected = false;
    });
    this.nextStep.emit(3);
  }

  stingUpperCase(str){
    let e = str.toLowerCase()
    return e.replace(/\b\w/g, l => l.toUpperCase())
  }

    getPrice(item): number {

    let price: number = 0;

      if((item?.addonsIncluded && item?.addonsIncluded.length > 0) ||
         (item?.amenitiesIncluded && item?.amenitiesIncluded.length > 0)) {

       let additionalPaymentOffice: number = 0;
       let addonsIncludedPaymentOffice: any[] = [];

       if(item?.addonsIncluded && item?.addonsIncluded.length > 0) {
        addonsIncludedPaymentOffice = item?.addonsIncluded.filter(c => c.PaymentOffice === true || c.paymentOffice === true);
       } else if(item?.amenitiesIncluded && item?.amenitiesIncluded.length > 0) {
        addonsIncludedPaymentOffice = item?.amenitiesIncluded.filter(c => c.PaymentOffice === true || c.paymentOffice === true);
       }
      additionalPaymentOffice = addonsIncludedPaymentOffice.reduce((total, addon) => {

        let priceProf: number = 0;

        switch(item.category_id) {
          case 1: // Hotel
            priceProf =  total + ((addon.price || 0) * (addon.qtyOptional || 1));
            break;
          case 2: // Rent a car
            priceProf =  total + ((addon.totalNetPriceProf || 0) * (addon.qtyOptional || 1));
            break;
          case 6: // Tour
            priceProf =  total + ((addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
          case 8: // Traslado
            priceProf =  total + (addon?.totalPrice || 0);
            break;
          case 9: // Ticket
            priceProf =  total + ((addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
        }

        return total + (priceProf || 0);
      }, 0);

      if(additionalPaymentOffice > 0) {
        price = item.netPriceBooking - additionalPaymentOffice;
      }
    } else {
      price = item.netPriceBooking;
    }

    return price;
  }

  getPaymentOffice(item): boolean {

    let addonsIncludedPaymentOffice: boolean = false;

      if(item?.addonsIncluded && item?.addonsIncluded.length > 0) {
        addonsIncludedPaymentOffice = item?.addonsIncluded.some(c => c.PaymentOffice === true || c.paymentOffice === true);
       } else if(item?.amenitiesIncluded && item?.amenitiesIncluded.length > 0) {
        addonsIncludedPaymentOffice = item?.amenitiesIncluded.some(c => c.PaymentOffice === true || c.paymentOffice === true);
       }

    return addonsIncludedPaymentOffice;
  }

  getSumPaymentOffice(item): number {

    let additionalPaymentOffice: number = 0;
    let addonsIncludedPaymentOffice: any[] = [];

      if(item?.addonsIncluded && item?.addonsIncluded.length > 0) {
        addonsIncludedPaymentOffice = item?.addonsIncluded.filter(c => c.PaymentOffice === true || c.paymentOffice === true);
       } else if(item?.amenitiesIncluded && item?.amenitiesIncluded.length > 0) {
        addonsIncludedPaymentOffice = item?.amenitiesIncluded.filter(c => c.PaymentOffice === true || c.paymentOffice === true);
       }
      additionalPaymentOffice = addonsIncludedPaymentOffice.reduce((total, addon) => {

        let priceProf: number = 0;

        switch(item.category_id) {
          case 1: // Hotel
            priceProf =  total + ((addon.totalNetPriceProf || addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
          case 2: // Rent a car
            priceProf =  total + ((addon.totalNetPriceProf || addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
          case 6: // Tour
            priceProf =  total + ((addon.totalNetPriceProf || addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
          case 8: // Traslado
            priceProf =  total + (addon?.totalPrice || 0);
            break;
          case 9: // Ticket
            priceProf =  total + ((addon.totalNetPriceProf || addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
        }

        return total + (priceProf || 0);
      }, 0);

    return additionalPaymentOffice;
  }
}

